module.exports = __webpack_public_path__ + "static/media/fisdom_hni_logo_dark.b9a5de34.svg";